import Vue from 'vue'
import Router from 'vue-router'
import Wrapper from '@/components/Wrapper'
import GeneralDashboard from '@/components/a_generalDashboard/GeneralDashboard'
import MyLeadForms from '@/components/b_MyLeadForms/MyLeadForms'
import Forms from '@/components/b_MyLeadForms/forms'
import LeadsProcessed from '@/components/c_LeadsProcessed/LeadsProcessed'
import MyQuestionnaireForms from '@/components/d_MyQuestionnaireForms/MyQuestionnaireForms'
import QuestionnaireProcessed from '@/components/e_QuestionnaireProcessed/QuestionnaireProcessed'
import ExportData from '@/components/f_ExportData/ExportData'
import GlobalAdministration from '@/components/k_globalAdministration/globalAdmin'
import Users from '@/components/i_users/Users'

Vue.use(Router);

export default{
  path: '/',
  component: Wrapper,
  children: [
    {
      path: '/general-dashboard',
      name: 'GeneralDashboard',
      component: GeneralDashboard,
      meta:{requiredAuth: true}
    },
    {
      path: '/my-lead-forms',
      name: 'MyLeadForms',
      component: MyLeadForms,
      meta:{requiredAuth: true}
    },
    {
      path: '/leads-processed',
      name: 'LeadsProcessed',
      component: LeadsProcessed,
      meta:{requiredAuth: true}
    },
    {
      path: '/my-questionnaire-forms',
      name: 'MyQuestionnaireForms',
      component: MyQuestionnaireForms,
      meta:{requiredAuth: true}
    },
    {
      path: '/questionnaire-processed',
      name: 'QuestionnaireProcessed',
      component: QuestionnaireProcessed,
      meta:{requiredAuth: true}
    },
    {
      path: '/export-data',
      name: 'ExportData',
      component: ExportData,
      meta:{requiredAuth: true}
    },
    {
      path: '/global-administration',
      name: 'GlobalAdministration',
      component: GlobalAdministration,
      meta: {requiredAuth: true}
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      meta: {requiredAuth: true}
    },
    {
      path: '/forms',
      name: 'forms',
      component: Forms,
      meta: {requiredAuth: true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/Pages.router.js